"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleAutosubmit = void 0;
var _actionGenerator = require("../../types/redux/actionGenerator");
var _types = require("./types");
const toggleAutosubmit = exports.toggleAutosubmit = (0, _actionGenerator.actionGenerator)(_types.EToggleAutosubmitActionTypes.Toggle);